import { useMutation, useQuery } from "@tanstack/react-query"
import { deleteQuery, generateQuery, listQueries, runQuery, saveQuery, updateQuery } from "@/lib/http/editor"

export const useRunQuery = (options: {
  onSuccess?: (data: any) => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: (data: { resource_id: string; query: string }) => runQuery(data),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })

export const useGenerateQuery = (options: {
  onSuccess?: (data: { query: string }) => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: (data: { resource_id: string; question: string }) => generateQuery(data),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })

export const useUpdateQuery = (options: {
  onSuccess?: (data: { query: string }) => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: (data: { resource_id: string; sql: string; question: string; selected_sql?: string }) =>
      updateQuery(data),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })

export const useListSavedQueries = () =>
  useQuery({
    queryKey: ["editor", "saved-queries"],
    queryFn: listQueries,
  })

export const useSaveQuery = (options: {
  onSuccess?: (data: any) => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: (data: {
      name?: string
      sql: string
      default_resource_id?: string
      is_favorite?: boolean
      id?: string
    }) => saveQuery(data),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })

export const useDeleteQuery = (options: {
  onSuccess?: () => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: (id: string) => deleteQuery(id),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })
